import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo, useState } from "react";
import { Badge, Button, Heading } from "../../../element";
import { SET_SIZE } from "./GridSetSize";
import { LinkGrid } from "./LinkGrid";
import { Container } from "./LinkGrid/LinkGrid.styles";
var BACKGROUND_COLORS = [
    "primary",
    "primaryGradient1",
    "natural70",
    "warning20", 
];
var getColor = function() {
    return BACKGROUND_COLORS[Math.floor(Math.random() * BACKGROUND_COLORS.length)];
};
var addColorsToLinks = function(links) {
    return links.map(function(link) {
        return _object_spread_props(_object_spread({}, link), {
            color: getColor(),
            hidden: false
        });
    });
};
var splitIntoSets = function(links) {
    var sets = [];
    for(var index = 0; index < links.length; index += SET_SIZE){
        sets.push(links.slice(index, index + SET_SIZE));
    }
    return sets;
};
export var GridLinkList = function(param) {
    var _content = param.content, badge = _content.badge, heading = _content.heading, links = _content.links, translations = param.translations;
    var ref = translations || {}, _allDestinationsLabel = ref.allDestinationsLabel, allDestinationsLabel = _allDestinationsLabel === void 0 ? "" : _allDestinationsLabel, _moreDestinationsLabel = ref.moreDestinationsLabel, moreDestinationsLabel = _moreDestinationsLabel === void 0 ? "" : _moreDestinationsLabel;
    var ref1 = useState(1), visibleSetCount = ref1[0], setVisibleSetCount = ref1[1];
    var coloredLinks = useMemo(function() {
        return addColorsToLinks(links);
    }, [
        links
    ]);
    var visibleItems = visibleSetCount * SET_SIZE;
    var hasMoreItemsToShow = visibleItems < links.length;
    var hasOneMoreSetRemaining = visibleItems + SET_SIZE > links.length;
    var sets = splitIntoSets(coloredLinks);
    var visibleSets = sets.map(function(set, index) {
        if (visibleSetCount < index + 1) {
            return set.map(function(link) {
                return _object_spread_props(_object_spread({}, link), {
                    hidden: true
                });
            });
        }
        return set;
    });
    var incrementSets = function() {
        setVisibleSetCount(visibleSetCount + 1);
    };
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            /*#__PURE__*/ _jsx(Badge, {
                content: badge,
                rules: {
                    badge: {
                        style: "orange"
                    }
                }
            }),
            /*#__PURE__*/ _jsx(Heading, {
                content: heading,
                rules: {
                    verticalSpacing: {
                        spacingDirection: "both"
                    }
                }
            }),
            /*#__PURE__*/ _jsx(LinkGrid, {
                content: {
                    sets: visibleSets
                }
            }),
            hasMoreItemsToShow && /*#__PURE__*/ _jsx(Button, {
                content: {
                    label: hasOneMoreSetRemaining ? allDestinationsLabel : moreDestinationsLabel
                },
                onClick: incrementSets,
                rules: {
                    variant: "secondary",
                    expanded: true,
                    horizontalSpacing: {
                        isCentered: true
                    },
                    verticalSpacing: {
                        spacingDirection: "neither"
                    }
                }
            })
        ]
    });
};
